<div class="property-data-container general-order-data">
    <div class="container header">
        <div class="row h-100">
            <div class="col-sm-6 title">
                <label>GENERAL ORDER DATA</label>
            </div>
        </div>
    </div>
    <div class="container">
		<div class="row form-section">
            <div class="col">
                <h5 class="section-title">
					GSE Details
					<span class="message-public-record">
                        (Fungibility for this order is <strong>{{fungibleStatus}}</strong>)
                    </span>
				</h5>
                <div class="row">
                    <div class="col-sm-2">
						<cv-schema-render-form-field
							[options]="{
								path: 'InspectionReport.lPAKey'
							}"
                        	[indexTab]="1">
                        </cv-schema-render-form-field>
					</div>
					<div class="col-sm-2">
						<cv-schema-render-form-field
							[options]="{
								path: 'InspectionReport.caseFileID'
							}"
                        	[indexTab]="1">
                        </cv-schema-render-form-field>
					</div>
					<div class="col-sm-2">
						<cv-schema-render-form-field
						*ngIf="hasAvailableLenders"
							[options]="{
								label: 'Lender',
								path: 'InspectionReport.cv_lender.cv_name',
								isDropdown: true,
								listItems: availableLenders,
								optionText: 'name',
								optionValue: 'name',
                                associtedPaths: [
                                    {
                                        path: 'InspectionReport.lenderContactInformation',
                                        mapper: 'contactInformation'
                                    },
                                    {
                                        path: 'InspectionReport.cv_lender.cv_unparsedAddress',
                                        mapper: 'unParsedAddress'
                                    }
                                ]
							}"
                        	[indexTab]="1">
                        </cv-schema-render-form-field>
					</div>
					<div class="col-sm-2">
						<cv-schema-render-form-field
							[options]="{
								path: 'InspectionReport.sellerId'
							}"
                        	[indexTab]="1">
                        </cv-schema-render-form-field>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-2">
						<cv-schema-render-form-field
							[options]="{
								path: 'InspectionReport.borrower'
							}"
							[indexTab]="1">
						</cv-schema-render-form-field>
					</div>
					<div class="col-sm-2">
						<cv-schema-render-form-field
							[options]="{
								path: 'InspectionReport.loanReason'
							}"
							[indexTab]="1">
						</cv-schema-render-form-field>
					</div>
					<div class="col-sm-2">
						<cv-schema-render-form-field
							[options]="{
								path: 'InspectionReport.loanNumber'
							}"
							[indexTab]="1">
						</cv-schema-render-form-field>
					</div>
				</div>
			</div>
		</div>

		<div *ngIf="isEditing"
                 class="row add-btn text-right">

                <button type="button"
                        class="btn btn-save btn-primary btn-small"
                        [disabled]="isSavingInProcess || isPristine || !viewsService.form.valid"
                        (click)="saveChanges()"
                        tabindex="1">
						<i class="fa-regular fa-save"></i>Save changes
                    <i *ngIf="isSavingInProcess"
                       class="fas fa-spinner fa-spin"></i>
                </button>
            </div>
	</div>
</div>
